import React from "react";
import { profile } from "../../data/site";

/** Plain facts only. The old "years / projects / support" counters were unverifiable. */
const facts = [
  ["Based in", profile.location],
  ["Studying", "M.Tech Computer Science, Manipal Institute of Technology"],
  ["Focus", profile.focus],
  ["Published", "CUDAnet, IEEE ICNPCV 2026"],
  ["Code", "github.com/DEADSERPENT"],
];

const Info = () => (
  <dl className="about__facts">
    {facts.map(([term, value]) => (
      <div key={term}>
        <dt>{term}</dt>
        <dd>{value}</dd>
      </div>
    ))}
  </dl>
);

export default Info;
